var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "af837bf68b260e0f0e5c8bd07c8307eda28bf59b"
};